import React, { Component } from 'react'
import { connect } from 'react-redux'
import EdgebetTable from 'components/edgebets/EdgebetTable'
import OptionRow from 'components/edgebets/OptionRow'
import { firebaseRef, bookmakers } from 'config'
import SelectedEdge from 'components/edgebets/SelectedEdge'
import { calculateTotalBankroll } from 'utils/calculations'
import { getCachedEdgebetFilters, saveEdgebetFilterInCache, getHiddenEdges, hideEdge, clearHiddenEdges } from 'utils/cache'
import { recommendedLeagues, NOTIFICATION_SOUND_URL } from 'config'
import 'css/edgebets.less'


class EdgebetContainer extends Component {

	constructor(props) {
		super(props)
		this.state = {
			edges: {},
			selectedEdge: null,
			filters: getCachedEdgebetFilters(),
			query: '',
			loading:true,
			hiddenEdges: getHiddenEdges(),
			changes: false
		}
		if (!this.state.filters.bookmakerList)
			this.state.filters.bookmakerList = Object.keys(this.props.bookmakerLists)[0]
		this.audio = new Audio(NOTIFICATION_SOUND_URL)
		this.edgeUpdates = {added: {}, modified: {}, removed: {}}
		this.lastEdgebets = []
		this.onEdgeAdded = this.onEdgeAdded.bind(this)
		this.onEdgeChanged = this.onEdgeChanged.bind(this)
		this.onEdgeRemoved = this.onEdgeRemoved.bind(this)
		this.updateEdges = this.updateEdges.bind(this)
		this.onEdgeSelected = this.onEdgeSelected.bind(this)
		this.onEditFilter = this.onEditFilter.bind(this)
		this.filterEdgebets = this.filterEdgebets.bind(this)
		this.edgeRef = firebaseRef.child('edges')
		this.onQueryChanged = this.onQueryChanged.bind(this)
		this.onHideEdge = this.onHideEdge.bind(this)
		this.clearHiddenEdges = this.clearHiddenEdges.bind(this)
		this.edgeChanges = false;
		this.tick = setInterval(() => this.updateEdges(), 1000)
	}

	updateEdges() {
		if (!this.edgeChanges)
			return
		for (let key in this.edgeUpdates.added) {
			this.state.edges[key] = this.edgeUpdates.added[key]
		}
		for (let key in this.edgeUpdates.modified) {
			this.state.edges[key] = this.edgeUpdates.modified[key]
		}
		this.edgeUpdates = { added: {}, modified: {} }
		this.edgeChanges = false
		this.setState({edges: this.state.edges})
	}

	onHideEdge(edge) {
		let hiddenEdges = hideEdge(edge)
		this.setState({
			hiddenEdges
		})
	}

	clearHiddenEdges() {
		clearHiddenEdges()
		this.setState({
			hiddenEdges: []
		})
	}

	onEdgeAdded(snap) {
		this.edgeChanges = true
		if (this.edgeUpdates[snap.key()] === undefined) {
			this.edgeUpdates.added[snap.key()] = Object.assign({}, snap.val(), {key: snap.key()})
		}
	}

	onEdgeChanged(snap) {
		this.edgeChanges = true
		this.edgeUpdates.modified[snap.key()] = Object.assign({}, snap.val(), {key: snap.key()})
	}

	onEdgeRemoved(snap) {
		this.edgeChanges = true
		if (!!this.state.selectedEdge) {
			if (+snap.key() === this.state.selectedEdge) {
				this.setState({selectedEdge: null})
			}
		}
		delete this.state.edges[snap.key()]
		delete this.edgeUpdates.added[snap.key()]
		delete this.edgeUpdates.modified[snap.key()]
	}

	componentDidMount() {
		window.analytics.page('Edgebets')
		//get initial edges
		this.edgeRef.once('value', snap => {
			let edges = {}
			if (snap.exists()) {
				edges = snap.val()
				Object.keys(edges).forEach(k => {
					edges[k].key = k
				})
			}
			this.setState({edges, loading:false})
			//start listening for new edges, order by created at.
			this.edgeRef.on('child_added', this.onEdgeAdded) // .orderByChild('createdAt').limitToLast(1)
		})
		this.edgeRef.on('child_changed', this.onEdgeChanged)
		this.edgeRef.on('child_removed', this.onEdgeRemoved)
	}

	onEdgeSelected(edgeId) {
		this.setState({
			selectedEdge: edgeId
		})
	}

	componentWillUnmount() {
		clearInterval(this.tick)
		this.edgeRef.off('child_added', this.onEdgeAdded)
		this.edgeRef.off('child_changed', this.onEdgeChanged)
		this.edgeRef.off('child_removed', this.onEdgeRemoved)
		document.title = 'Edgebet'
	}

	onEditFilter(key, value) {
		let filters = Object.assign({}, this.state.filters)
		filters[key] = value
		this.setState({
			filters
		})
		saveEdgebetFilterInCache(key, value)
	}

	onQueryChanged(query) {
		this.setState({
			query
		})
	}

	filterEdgebets() {
		let filters = []
		let bookmakerList = this.props.bookmakerLists[this.state.filters.bookmakerList]
		if (!bookmakerList)
			bookmakerList = Object.keys(this.props.bookmakerLists).map(k => this.props.bookmakerLists[k])[0]
		if (bookmakerList) {
			let lBookmakers = Object.keys(bookmakerList.bookmakers).map(k => +k)
			filters.push(edge => lBookmakers.indexOf(edge.bookmaker) > -1)
		}
		if (this.state.hiddenEdges.length > 0) {
			filters.push(edge => this.state.hiddenEdges.indexOf(edge.offer) === -1)
		}
		if (this.state.filters.recommendedLeagues)
			filters.push(edge => {
				if (edge.competition._id) {
					return recommendedLeagues.indexOf(edge.competition._id) > -1
				} else {
					return false
				}
			})
		if (this.state.filters.lowRisk)
			filters.push(edge => edge.odds < 4 && edge.edge > 3)
		if (this.state.filters.next12hours) {
			let in12hours = Date.now() + 1000 * 60 * 60 * 12 // 12 hours in MS
			filters.push(edge => edge.startTime < in12hours)
		}
		if (!!this.state.query) {
			const { query } = this.state
			let regex = new RegExp(query, 'i')
			filters.push(edge => {
				return (
				  regex.test(edge.homeTeam) ||
				  regex.test(edge.awayTeam) ||
				  regex.test(edge.competition.name) ||
				  regex.test(bookmakers[edge.bookmaker])
				)
			})
		}
		let filter
		if (filters.length > 0) {
			filter = filters.reduce((a, b) => edge => a(edge) && b(edge))
			return Object.keys(this.state.edges)
				.map(key => this.state.edges[key])
				.filter(filter)
		}
		return Object.keys(this.state.edges).map(key => this.state.edges[key])
	}

	render() {
		if(this.state.loading) {
			return (<div className='container-fluid text-center'><i className='fa fa-spinner fa-3x fa-spin'></i></div>)
		}
		let edgebets = this.filterEdgebets()
		if (this.state.filters.sound) {
			for (let i = 0; i < edgebets.length; i++) {
				if (this.lastEdgebets.indexOf(edgebets[i].offer) === -1) {
					this.audio.play()
					break
				}
			}
		}
		this.lastEdgebets = edgebets.map(k => k.offer)

		let totalBankroll = calculateTotalBankroll(this.props.user.startingBankroll,
		                                           this.props.userbets,
		                                           this.props.currencies,
		                                           this.props.user.currency)

		return (
			<div className="container-fluid edgebet-container">
				<div className='row'>
					<div className='edgebet-table-column col-md-8'>
						<div className='panel'>
							<div className='panel-body'>
								<OptionRow
									onChange={this.onEditFilter}
									bookmakerLists={this.props.bookmakerLists}
									onQueryChanged={this.onQueryChanged}
									clearHiddenEdges={this.clearHiddenEdges}
									{ ...this.state.filters }/>

								<EdgebetTable
									shouldAnimate={this.state.query.length === 0}
									edgebets={edgebets}
									selected={this.state.selectedEdge}
									onEdgeSelected={this.onEdgeSelected}
									user={ this.props.user }
									userbets={ this.props.userbets}
									totalBankroll={ totalBankroll }
								/>
							</div>
						</div>
					</div>
					<div className='col-md-4 selected-edge-outer'>
						<SelectedEdge
							userbets={this.props.userbets}
							user={ this.props.user }
							totalBankroll={ totalBankroll }
							onHideEdge={this.onHideEdge}
							hidden={
								this.state.selectedEdge ? this.state.hiddenEdges.indexOf(+this.state.selectedEdge.split('_')[0]) !== -1 : false
							}
							edge={this.state.edges[this.state.selectedEdge]} />
					</div>
				</div>
			</div>
		)
	}
}

export default connect(state => {
	return {
		userbets: state.userbets,
		currencies: state.currencies,
		bookmakerLists: state.bookmakerLists
	}
})(EdgebetContainer)



/** WEBPACK FOOTER **
 ** ./src/containers/EdgebetContainer.js
 **/